import React, { useState,useCallback,forwardRef } from 'react';

const CharCounterInput = forwardRef((props, ref) => {
    const [inputValue, setInputValue] = useState('');
    const maxChars = 250;
    
    const handleChange = useCallback(
        (event) => {
            let value=event.target.value;
            // Only update the state if the new value is within the character limit
            if (value.length <= maxChars) {
                setInputValue(value);
                props.onChange(event); // Pass the new value along with the call
            }
        },
        [maxChars, props]
    );

    return (
            <><div><input
            ref={ref}
            placeholder={props.placeholder}
            className={props.className}
            autoFocus={props.autoFocus}
            onChange={handleChange}
            type={props.type}
            value={inputValue}
            maxLength={maxChars} />
            <div  className="maxLimit">
                {inputValue.length}/{maxChars}
            </div></div></>
    );
});

export default CharCounterInput;